import { paperlessNavController } from '@/paperless-kenwood/Controllers/PaperlessNavController';
import { paperlessChatController } from '@/paperless-kenwood/Controllers/PaperlessChatController';
import PaperlessManualsController from '@/paperless-kenwood/Controllers/PaperlessManualsController';

import PdpFaqsController from '@/utils/Controllers/PdpFaqsController';
import PaperlessHowToVideos from '@/paperless-kenwood/Controllers/PaperlessHowToVideos';

document.addEventListener('DOMContentLoaded', () => {
  paperlessNavController.init();
  paperlessChatController.init();
  PaperlessManualsController();
});

window.addEventListener('load', () => {
  PdpFaqsController();
  PaperlessHowToVideos();
});
